import React from "react";
import styled from "styled-components";
import PositionContainer from "../shared/container";
import MainTitle from "../shared/heroTitles";
import Paragraph from "../shared/paragraphs";
import ContentBox from "../shared/contentBox";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { useIntl } from "gatsby-plugin-react-intl";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 40px 0px;

  a {
    color: #111111;
  }
  @media (max-width: 960px) {
    height: max-content;
    width: 100%;
  }
  .img {
    @media (max-width: 960px) {
      width: 45%;
    }

    @media (max-width: 768px) {
      width: 327px;
      height: 246px;
    }
  }

  .gatsby-image-wrapper {
    img {
      @media (min-width: 960px) {
        padding: 16px;
      }
    }
  }
`;

const ContentHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 50px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  &:nth-child(1) {
    flex-direction: column;
  }
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  margin-top: 30px;
  @media (max-width: 560px) {
    width: 100%;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }
`;

const Box = styled.div`
  height: fit-content;
  width: fit-content;
  @media (max-width: 960px) {
    width: 100%;
  }
`;

function Img1() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-download-button-1.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-download-button-1.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}
function Img2() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-install-file-highlighted-2.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-install-file-highlighted-2.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Uninstall Image 3"
      className="img"
    />
  );
}

function Img3() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-install-wizard-instruction-3.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-install-wizard-instruction-3.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  );
}

function Img4() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-install-progress-4.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-install-progress-4.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  );
}

function Img5() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-license-key-5.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-license-key-5.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  );
}

function Img6() {
  const intl = useIntl();
  const Lang = intl.locale;

  return Lang == "fr" ? (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.fr-activate-license-button-6.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  ) : (
    <StaticImage
      src="../../images/installationPageImages/install/pdfcreator.es-activate-license-button-6.png"
      quality={95}
      formats={["AUTO", "WEBP", "AVIF", "PNG"]}
      alt="Install Image 3"
      className="img"
    />
  );
}

function Hero() {
  const intl = useIntl();

  return (
    <Container>
      <PositionContainer>
        <ContentHolder>
          <Row>
            <MainTitle features={true}>
              {intl.formatMessage({
                id: "InstructionTitle",
              })}
            </MainTitle>
            <TextContainer>
              <Paragraph type="center">
                {intl.formatMessage({
                  id: "InstructionUnderTitle",
                })}
              </Paragraph>
            </TextContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 1`}
                  instalWidth={true}
                >
                  <Paragraph>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: intl.formatMessage({
                          id: "InstructionInstallStepOne",
                        }),
                      }}
                    />
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 2`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionInstallStepTwo",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 3`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionInstallStepThree",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 4`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionInstallStepFour",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 5 (PURCHASE)`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionInstallStepFivePurchase",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
              <Box>
                <ContentBox
                  title={` ${intl.formatMessage({
                    id: "Step",
                  })} 5 (TRIAL)`}
                  instalWidth={true}
                >
                  <Paragraph>
                    {intl.formatMessage({
                      id: "InstructionInstallStepFiveTrial",
                    })}
                  </Paragraph>
                </ContentBox>
              </Box>
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img1 />
              <Img2 />
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img3 />
              <Img4 />
            </FlexContainer>
          </Row>
          <Row>
            <FlexContainer>
              <Img5 />
              <Img6 />
            </FlexContainer>
          </Row>
        </ContentHolder>
      </PositionContainer>
    </Container>
  );
}

export default Hero;
